import {
  validationGenerator,
  appearanceGenerator,
  visibilityGenerator
} from "./form.util.js";
import { differenceWith } from "../../libs/utils/index.js";
import { FieldURLMapping, PublicFieldURLMapping } from "./url.js";
import {
  FIELD_TYPES,
  LIST_DATASOURCE_TYPE
} from "@base/common/constants/index.js";

export function constructGridFieldObj(
  metadataModel,
  columnsFields,
  systemFields,
  isPublicForm,
  currentStep = ""
) {
  let excludedColumns = [];
  let hiddenFields = [];
  if (metadataModel.isProcess()) {
    let step = metadataModel
      .getList("Model", "ProcessDef")[0]
      .getList("ProcessDef", "Activity")[0];
    if (step) {
      let permissionList = step.getList("Activity", "Permission");
      excludedColumns = permissionList.filter((permission) => {
        if (permission.getValue("Permission") === "Hidden") {
          return permission.getValue("Column");
        }
        return ""; // arrow function needs return
      });
    }
  }
  for (let i in columnsFields) {
    var columnField = columnsFields[i];
    columnField["hasConstraint"] = metadataModel
      .getObject(columnsFields[i].Id)
      .hasConstraint();
    columnField["Visible"] = true;
    if (!columnField.IsSystemField && metadataModel) {
      var field = metadataModel.getObject(columnField.Id);
      let column = field.get("Column");
      if (
        column.getValue("DefaultPermission") !== "Hidden" &&
        excludedColumns.indexOf(column.id) === -1
      ) {
        let rowId = column.getValue("Row");
        let rowObject = metadataModel.getObject(rowId);
        let parentColumn = metadataModel.getObject(
          rowObject.getValue("Column")
        );
        let validationGeneratorResult = validationGenerator(
          field,
          [],
          systemFields
        );
        let appearanceResult = appearanceGenerator(
          column,
          [],
          currentStep,
          systemFields
        );
        let visibilityGeneratorResult = visibilityGenerator(
          column,
          systemFields
        );
        let visibilitySectionGeneratorResult = visibilityGenerator(
          parentColumn,
          systemFields
        );
        let QueryDefinition = field.getQueryDef()[0];
        let RemoteLookupJson = field.getRemoteLookupDef();
        Object.assign(columnField, field.currentJson);
        columnField["IsHidden"] = column.getValue("IsHidden") === true;
        columnField["Validationfun"] = validationGeneratorResult[0];
        columnField["Hint"] = column.getValue("Hint");
        columnField["Visibility"] = visibilityGeneratorResult;
        columnField["sourceUrl"] = getSourceUrl(
          metadataModel,
          field,
          isPublicForm
        );
        columnField["VisibilitySection"] = visibilitySectionGeneratorResult;
        columnField["Field"] = field;
        if (columnField["Widget"] === FIELD_TYPES.REMOTE_LOOKUP) {
          columnField["RemoteLookupResultType"] =
            RemoteLookupJson.getResultType();
          columnField["RemoteLookupTrigger"] = RemoteLookupJson.getTrigger();
        }
        if (
          columnField["Type"] === FIELD_TYPES.REFERENCE ||
          columnField["Type"] === FIELD_TYPES.USER ||
          (columnField["Type"] === FIELD_TYPES.SELECT &&
            (columnField["DatasourceType"] === LIST_DATASOURCE_TYPE.DATASET ||
              columnField["DatasourceType"] === LIST_DATASOURCE_TYPE.DATAFORM))
        ) {
          columnField["QueryDefinition"] = QueryDefinition;
        }
        if (
          columnField["Type"] === FIELD_TYPES.ATTACHMENT ||
          columnField["Type"] === FIELD_TYPES.IMAGE
        ) {
          columnField["fieldWrapper"] = field;
        }
        columnField["Appearance"] = appearanceResult;
      }
    }
    if (
      columnField["IsHidden"] === true &&
      columnField["Visibility"] &&
      columnField["Visibility"].isEmpty()
    ) {
      hiddenFields.push(columnField);
    }
  }
  columnsFields = differenceWith(
    columnsFields,
    hiddenFields,
    function columnFieldMatch(columnField, hiddenField) {
      return columnField["Id"] === hiddenField["Id"];
    }
  );
  return columnsFields;
}

function isReadonly(permission, column) {
  return (
    permission === "Print" ||
    (column.QueryDefinition && column.QueryDefinition.getValue("AutoFill")) ||
    (column && column["Field::Expression"]) ||
    column.Widget === FIELD_TYPES.AGGREGATION
  );
}

export function getChildColumns(
  columns,
  permission,
  {
    isStartStep,
    currentStep,
    status,
    isAdmin,
    isSendBackToInitiator,
    isPublicForm
  },
  systemFields
) {
  let childModel = columns.getList("Column", "Model")[0];
  let mainModel = columns.getModel();
  // let tablePermissionMap = {};
  // let tablePermission =
  //   permission === "Print"
  //     ? "ReadOnly"
  //     : permission[columns.getValue("Id")] && permission[columns.getValue("Id")]["ColumnPermission"];
  let childRow = childModel.getList("Model", "Row");
  let columnList = childRow[0] && childRow[0].getList("Row", "Column");
  let childColumnIdList = columnList.map((column) => {
    let field = column.getList("Column", "Field")[0];
    return field && field["currentJson"];
  });
  let childColumns = constructGridFieldObj(
    mainModel,
    childColumnIdList,
    systemFields,
    isPublicForm,
    currentStep
  );
  childColumns = childColumns.map((column, index) => {
    // tablePermissionMap[column["Id"]] = permissionGenerator(
    //   childModel.getObject(column["Column"]),
    //   tablePermission,
    //   isStartStep,
    //   currentStep,
    //   status,
    //   isSendBackToInitiator
    // );
    // if (
    //   tablePermissionMap[column["Id"]] &&
    //   tablePermissionMap[column["Id"]]["ColumnPermission"] === "Hidden"
    // ) {
    //   return null;
    // }
    let columnWidth =
      childModel.getObject(column.Column) &&
      childModel.getObject(column.Column).getValue("Width");
    columnWidth =
      columnWidth && columnWidth.substring(0, columnWidth.length - 2);
    return {
      ...column,
      ReadOnly: isReadonly(permission, column),
      Width: permission !== "Print" && columnWidth
    };
  });
  childColumns = childColumns.filter((column) => {
    return column !== null;
  });
  return childColumns;
}

const getSourceUrl = (model, field, isPublicForm) => {
  let mapping = FieldURLMapping;
  if (isPublicForm) {
    mapping = PublicFieldURLMapping;
  }
  let fieldType = field.getValue("Type");
  return mapping[fieldType];
};
